import React, { PureComponent } from 'react'
import PropTypes from 'prop-types';

import tagsConfigHelper from '../../../helpers/tagsConfigHelper'
import ControlManager from '../ControlManager'
import {
    START_VALIDATE_TAGS,
    ADD_TAG_ERROR
} from '../../../redux/actions/actionTypes'

class InputNumber extends PureComponent {
    constructor(props) {
        super(props)

        this.inputRef = React.createRef();

        this.state ={}

        this.initState=this.initState.bind(this)
        this.initControl = this.initControl.bind(this)
        const validate= this.validate.bind(this)

        this.initState()

        // window.emitter.addListener(START_VALIDATE_TAGS, function (message) {
        //     validate()
        // })
    }

    initState(){
        let {doctype}=this.props

        this.state={
            visible: true,
            disabled: (!doctype || doctype=="")?this.props.disabled:false,
            required:false,
            description:null,
            error:false,
            error_message:null,

            input: "",
            start: 0,
            floatingPoint: (this.props.floatingPoint) ? this.props.floatingPoint:2,
        }
    }

    initControl() {
        let {doctype,tagid}=this.props
       
        if (!doctype || !tagid) return
        
        var tagInfo =tagsConfigHelper.findTagConfig(tagid, doctype)

        // console.log("Core InputDecimal.initControl()")
        // console.log(tagInfo)

            if(tagInfo){
                this.setState({
                    visible:tagInfo.visibled,
                    disabled: !tagInfo.enabled,
                    required:tagInfo.required,
                    description:tagInfo.tagDescription
                })

                ControlManager.setLabel(tagInfo.tagLabel,tagInfo.visibled,tagInfo.required)
                ControlManager.setSubLabel(tagInfo.tagSubLabel,tagInfo.visibled)
            }
    }

   async validate() {
        let {required,description}=this.state
        let {tagid,validate_required}=this.props
        let control=this.inputRef.current

        if(!control || !tagid || !required || validate_required===false) return

       // console.log("validate : ",tagid)

        this.setState({
            error: false,
            error_message: null
        })
        
        if(!control.value || control.value.length===0){
            let message="กรุณาระบุ " + (description!==null ? description :tagid)

          //console.log(control)

            this.setState({
                error:true,
                error_message: message
            })

         window.emitter.emit(ADD_TAG_ERROR, {
            tagId:tagid,
            description:description,
            error_message:this.state.error_message
        })
        }  
    }

    componentWillReceiveProps(nextProps) {        
        if (this.props.doctype !== nextProps.doctype) {
               this.initControl()
        }

        //กรณีไม่ได้กำหนด DocType บางค่าให้เชื่อตามที่กำหนดจากข้างนอก
        if(!nextProps.doctype || nextProps.doctype===""){
            if (this.state.disabled !== nextProps.disabled) {
                this.setState({disabled:nextProps.disabled})
                //เคลียร์ค่าเก่าใน textbox
                if(nextProps.disabled)
                {
                    this.inputRef.current.value = ''
                }
            }
        }


    }

    componentDidMount() {
        this.initControl()
    }


    onChange(event){
        // const maxDigits = 13
        const numeral = require('numeral');
        let { start,floatingPoint}  = this.state
        start = event.target.selectionStart;
        let val = event.target.value;       
        const value = numeral(val).format(this.props.format);
        event.target.value = value;
        // this.setState({ input: value });
        if (val.length > 0) {
          event.target.value = value;
          event.target.setSelectionRange(start, start);
          this.setState({ input: value });
        } 
        else { 
            this.setState({ input: val });
    }

        this.props.onChange(event)
      };

    render() {
        let { disabled, visible } = this.state

        if (this.props.doctype) {
            var tagInfo = tagsConfigHelper.findTagConfig(this.props.tagid, this.props.doctype)
            if (tagInfo) {
                disabled = !tagInfo.enabled
                visible = tagInfo.visibled
            }
        }

        return (
            <input
                ref={this.inputRef}
                //value={this.state.input}
                {...this.props}
                className={['form-control', this.props.className].join(' ')}
                //disabled={disabled ? "disabled" : null}
                disabled={disabled || this.props.viewMode ? "disabled" : null}
                style={{ visibility: visible ? "visible" : "hidden" }}
                onChange={(event) => this.onChange(event)}
            />
        )
    }    
}

InputNumber.defaultProps = {
    type: "text",
    floatingPoint: 2,
}

InputNumber.propTypes = {
    doctype: PropTypes.string,
    tagid: PropTypes.string,
    floatingPoint: PropTypes.number,
}

export default InputNumber